import { Injectable, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";
import { Nullable } from "ng/src/app/shared/model/app.model";
import { PersistentDialogController, PersistentDialogUpdate } from "ng/src/app/shared/persistent-dialog/persistent-dialog.model";

@Injectable({
	providedIn: 'root'
})
export class PersistentDialogService {
	
	templateSubject = new Subject<Nullable<PersistentDialogUpdate>>();
	closeSubject = new Subject();
	
	next(ref: Nullable<PersistentDialogUpdate>) {
		this.templateSubject.next(ref);
	}
	
	close() {
		this.closeSubject.next();
	}
}

@Injectable()
export class PersistentDialogChildService implements OnDestroy {
	private _controller!: PersistentDialogController;
	
	get controller() {
		return this._controller
	}
	set controller(val) {
		if (this._controller) return;
		this._controller = val;
	}
	
	set closeConfirmation(val: ((close: () => void) => void)) {
		this.controller.closeConfirmation = val;
	}
	
	private readonly destroySubject = new Subject();
	readonly destroy$ = this.destroySubject.asObservable();
	
	ngOnDestroy(): void {
		this.destroySubject.next();
	}
	
	close() {
		this.controller.close();
	}
}